import { render } from "./learningCenterTranslationErrorTab.vue?vue&type=template&id=50532133"
import script from "./learningCenterTranslationErrorTab.vue?vue&type=script&lang=js"
export * from "./learningCenterTranslationErrorTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__